import Enum from '@/Domain/interfaces/IEnum';

export const pendingQualificationType: Enum = {
    translations: {
        1: 'lang.exams.pendding',
        2: 'lang.exams.notPresented'
    },
    enum: {
        VALIDATEQUALIFICATIONS: 0,
        PENDING: 1,
        NOTPRESENTED: 2
    }
};
